import React, { useState } from 'react'
import { useContext } from 'react'
import { CandidatesContext } from '../../../utils/context'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { addCandidateBenefit, deleteCandidateBenefit, editCandidateBenefit, getCandidateBenefits, getBenefitsReference } from '../../../actions/candidates'
import styles from './styles.module.scss'
import Button from '../../../components/Button'
import Table from '../../../components/Table'
import Confirmation from '../../../components/Confirmation/Confirmation'
import { Input } from '../../../components/ModalInputs'
import CustomSelect from '../../../components/CustomSelect'


export default function Priveleges() {

  const { candidateId, closeModal } = useContext(CandidatesContext)
  const dispatch = useDispatch()
  const { benefits, benefits_reference } = useSelector(state => state.candidates.data)

  const [selectedCode, setSelectedCode] = useState(null)
  const [addMode, setAddMode] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const [newCode, setNewCode] = useState('')
  const [newAdditional, setNewAdditional] = useState('')
  const [newForWhom, setNewForWhom] = useState('')
  const [confirmation, setConfirmation] = useState(false)

  useEffect(() => {
    dispatch(getCandidateBenefits(candidateId))
    dispatch(getBenefitsReference())
  }, [])

  const list = Array.isArray(benefits) ? benefits : []
  const refList = Array.isArray(benefits_reference) ? benefits_reference : []

  const handleAdd = () => {
    if (!newCode) return
    dispatch(addCandidateBenefit(candidateId, {
      privilegecode: newCode,
      additional: newAdditional,
      privilege_family: newForWhom,
    }))
    setAddMode(false)
    setNewCode('')
    setNewAdditional('')
    setNewForWhom('')
  }

  const handleEditOpen = () => {
    if (!selectedCode) return
    const item = list.find(i => i.privilegecode === selectedCode)
    if (!item) return
    setNewCode(item.privilegecode)
    setNewAdditional(item.additional || '')
    setNewForWhom(item.privilege_family || '')
    setEditMode(true)
  }

  const handleEditSave = () => {
    dispatch(editCandidateBenefit(candidateId, selectedCode, {
      privilegecode: newCode,
      additional: newAdditional,
      privilege_family: newForWhom,
    }))
    setEditMode(false)
    setNewCode('')
    setNewAdditional('')
    setNewForWhom('')
  }

  const handleDeleteConfirm = () => {
    if (!selectedCode) return
    setConfirmation(true)
  }

  const acceptDelete = () => {
    dispatch(deleteCandidateBenefit(candidateId, selectedCode))
    setSelectedCode(null)
    setConfirmation(false)
  }

  return (
    <>
      {confirmation && (
        <Confirmation
          title='Удалить льготу?'
          acceptConfirmation={acceptDelete}
          rejectConfirmation={() => setConfirmation(false)}
        />
      )}
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <Table>
            <thead>
              <tr>
                <th>Льгота</th>
                <th>Дополнительно</th>
                <th>На кого</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item) => (
                <tr
                  key={item.privilegecode}
                  onClick={() => setSelectedCode(item.privilegecode)}
                  className={selectedCode === item.privilegecode ? styles.selectedRow : ''}
                >
                  <td>{item.privilegename}</td>
                  <td>{item.additional}</td>
                  <td>{item.privilege_family}</td>
                </tr>
              ))}
              {list.length === 0 && (
                <tr>
                  <td colSpan={3} style={{ textAlign: 'center', color: '#999' }}>Нет данных</td>
                </tr>
              )}
            </tbody>
          </Table>

          {(addMode || editMode) && (
            <>
              <div className={styles.inputsRow} style={{ marginTop: '0.75rem', alignItems: 'flex-end' }}>
                <CustomSelect
                  title='Льгота'
                  options={refList.map(r => ({ name: r.name, value: r.code }))}
                  value={newCode}
                  setFieldValue={(_, val) => setNewCode(val)}
                  valuesName='newCode'
                  withoutAll
                />
                <Input
                  label='Дополнительно'
                  value={newAdditional}
                  onChange={e => setNewAdditional(e.target.value)}
                  style={{ minWidth: '160px' }}
                />
                <Input
                  label='На кого'
                  value={newForWhom}
                  onChange={e => setNewForWhom(e.target.value)}
                  style={{ minWidth: '120px' }}
                />
              </div>
              <div className={styles.scheduleButtons}>
                <Button mode='bordered' onClick={editMode ? handleEditSave : handleAdd}>Сохранить</Button>
                <Button mode='bordered' onClick={() => { setAddMode(false); setEditMode(false) }}>Отмена</Button>
              </div>
            </>
          )}

          {!addMode && !editMode && (
            <div className={styles.scheduleButtons} style={{ marginTop: '0.75rem' }}>
              <Button mode='bordered' onClick={() => setAddMode(true)}>Добавить</Button>
              <Button mode='bordered' onClick={handleEditOpen} disabled={!selectedCode}>Изменить</Button>
              <Button mode='bordered' onClick={handleDeleteConfirm} disabled={!selectedCode}>Удалить</Button>
            </div>
          )}
        </div>
      </div>
      <div className={styles.modalFooter}>
        <div />
        <Button mode='white' onClick={closeModal}>Закрыть</Button>
      </div>
    </>
  )
}
